export { default as ResponsiveCarousel } from './responsive-carousel';
